import React from 'react';
import PubSub from 'pubsub-js';
import MenuItems from './menu-items';
import { docsForPath } from '../data/docs-links';
export default class AppDrawerMenu extends React.Component {
  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: "drawer-items"
    }, /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(MenuItems, {
      cls: "drawer-sidebar"
    })), /*#__PURE__*/React.createElement("section", {
      className: "drawer-help"
    }, /*#__PURE__*/React.createElement("a", {
      role: "button",
      tabIndex: 0,
      onClick: () => PubSub.publish('plunk-assistant-toggle', {})
    }, /*#__PURE__*/React.createElement("i", {
      className: "material-icons"
    }, "auto_awesome"), /*#__PURE__*/React.createElement("span", null, "Ask Plunk")), /*#__PURE__*/React.createElement("a", {
      href: docsForPath(window.location.pathname),
      target: "_blank",
      rel: "noreferrer",
      onClick: e => {
        e.currentTarget.href = docsForPath(window.location.pathname);
      }
    }, /*#__PURE__*/React.createElement("svg", {
      viewBox: "0 0 24 24",
      width: "22",
      height: "22",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      "aria-hidden": "true"
    }, /*#__PURE__*/React.createElement("circle", {
      cx: "12",
      cy: "12",
      r: "10"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 17h.01"
    })), /*#__PURE__*/React.createElement("span", null, "Help"))));
  }
}